import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NotifyService } from './notify.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-coming-soon',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.scss']
})
export class ComingSoonComponent implements OnInit {
  currentYear = new Date().getFullYear();
  isNotifyFormVisible = false;
  isSubmitting = false;
  isSuccess = false;
  notifyForm!: FormGroup;
  errorMessage: string | null = null;

  constructor(private notifyService: NotifyService, private fb: FormBuilder) {}

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.notifyForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  toggleNotifyForm() {
    this.isNotifyFormVisible = !this.isNotifyFormVisible;
    if (this.isNotifyFormVisible) {
      this.notifyForm.reset();
      this.isSuccess = false;
      this.errorMessage = null;
    }
  }

  get email() {
    return this.notifyForm.get('email');
  }

  submitNotify() {
    if (this.notifyForm.invalid || this.isSubmitting) {
      this.notifyForm.markAllAsTouched();
      return;
    }

    const email = this.notifyForm.value.email;
    this.isSubmitting = true;
    this.isSuccess = false;
    this.errorMessage = null;

    this.notifyService.notify(email)
      .pipe(
        finalize(() => this.isSubmitting = false)
      )
      .subscribe({
        next: () => {
          // On success, show the success message and hide the form fields
          this.isSuccess = true;
        },
        error: (error) => {
          // Handle already subscribed (HTTP 409) and other errors
          if (error?.status === 409 || error?.error?.statusCode === 409) {
            const backendMessage = error?.error?.message as string | undefined;
            this.errorMessage = backendMessage || `"${email}" is already subscribed.`;
          } else {
            console.error('Failed to send notification request', error);
            this.errorMessage = 'An error occurred. Please try again later.';
          }
        },
      });
  }
}
